import { queryOptions } from "@tanstack/react-query";
import { getAthleteProfile, type Api } from "api-client";
import { assert } from "utils";

export function athleteProfileQueryOptions(athleteId: string | undefined) {
  return queryOptions<Api.GetAthleteProfile.Output.Self>({
    queryKey: ["athletes", athleteId, "profile"],
    queryFn: async () => {
      assert(athleteId, "Athlete ID is required");

      const response = await getAthleteProfile({
        path: { athleteId },
      });
      return response.data.data;
    },
  });
}
